import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconDescriptionFn = /* @__PURE__ */ createRecipe('radio-icon-description', {}, [])

const radioOnlyIconDescriptionVariantMap = {}

const radioOnlyIconDescriptionVariantKeys = Object.keys(radioOnlyIconDescriptionVariantMap)

export const radioOnlyIconDescription = /* @__PURE__ */ Object.assign(memo(radioOnlyIconDescriptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconDescription',
  __getCompoundVariantCss__: radioOnlyIconDescriptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconDescriptionVariantKeys,
  variantMap: radioOnlyIconDescriptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconDescriptionVariantKeys)
  },
  getVariantProps: radioOnlyIconDescriptionFn.getVariantProps,
})